import {Select, Text} from '../1elements'
import FormHelperText from '@mui/material/FormHelperText'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'

const RecordsTypeSelect = ({disabled, onChange, value, validation, className}) => {
    const [trainingRecordsList, setTrainingRecordsList] = useState([])

    useEffect(()=>{
      const getTrainingRecordTypes = async () => {
        const res = await ApiService().getAllTrainingRecordTypes()
        setTrainingRecordsList(res)
      }
      getTrainingRecordTypes()
    }, [])

    return(
        <div className={className}>
            <Text type={'fieldLabel'}>Record Type<span className={'requiredAsterisk'}>*</span></Text>
            <Select value={value} onChange={onChange} options={trainingRecordsList} disabled={disabled} error={Boolean(validation)} optionIdKey={'record_type_id'} optionLabelKey={'record_type'}/>
            <FormHelperText error={Boolean(validation)}>{validation}</FormHelperText>
        </div>

    )
}

export default RecordsTypeSelect
